import { IIcon } from '../../model/icon';

export const back: IIcon = {
  id: `BACK`,
  svg: `
  <path d="M16 7.00008V9.00008H4L9.5 14.5001L8.08 15.9201L0.160004 8.00008L8.08 0.0800781L9.5 1.50008L4 7.00008H16Z" fill="white"/>
  `
};
